import { inject } from '@angular/core';

import { CanActivateFn } from '@angular/router';

import {
  MatDialog
} from '@angular/material/dialog';

import { AuthService }
from '../services/auth.service';


import {
  SubscriptionExpiryDialog
} from '../../shared/components/subscription-expiry-dialog/subscription-expiry-dialog';
import { SubscriptionAccessService } from '../services/subscription-access-service';

export const subscriptionGuard:
CanActivateFn = () => {

  const auth =
    inject(AuthService);

  const dialog =
    inject(MatDialog);

  const subscriptionAccess =
    inject(
      SubscriptionAccessService
    );

  // ======================================================
  // VALID SUBSCRIPTION
  // ======================================================

  if (
    auth.isSubscriptionActive()
  ) {

    subscriptionAccess.unblock();

    return true;
  }

  // ======================================================
  // BLOCK APP
  // ======================================================

  subscriptionAccess.block();

  // ======================================================
  // PREVENT MULTIPLE DIALOGS
  // ======================================================

  const alreadyOpened =
    dialog.openDialogs.some(
      dialogRef =>
        dialogRef.componentInstance instanceof
        SubscriptionExpiryDialog
    );

  if (!alreadyOpened) {

    dialog.open(
      SubscriptionExpiryDialog,
      {
        width: '100%',
        maxWidth: '600px',

        disableClose: true,
        closeOnNavigation: false,
        hasBackdrop: true,

        data: {
          isSubscriptionExpired:
            auth.isOver30DaysPast(),

          showForm: false,

          showDialogClose: false
        }
      }
    );
  }

  return true;
};